import axios from 'axios';

export const giftCardUtils = {
  viewBalance() {
    return axios.get('/gift_cards/view_balance');
  },
};
